// 
export default (element, classNames) => {
  const classList = element.classList;

  Object.keys(classNames).forEach((className) => {
    const valid = classNames[className];
    if (valid) {
      classList.add(className);
    } else {
      classList.remove(className);
    }
  });
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/lib/classNames.js